import { React } from 'react';
import { useHistory } from 'react-router-dom';
import styled from 'styled-components';

import TopBarLogoPath from '../../../image/TopBarLogo.png';

function TopBar() {
	const history = useHistory();

  return (
    <TopLevelWrapper>
      <TitleWrapper>
        <Logo src={TopBarLogoPath}/>
        <Title onClick={() => history.push('/main')}>LINKO ZONE</Title>
      </TitleWrapper>
    </TopLevelWrapper>
  );
}

export default TopBar;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  width: 100vw;
  height: 92px;
  
  background-color: #FFFFFF;
`;

const TitleWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  &:hover {
    cursor: pointer;
  }
`;

const Logo = styled.img`
  width: 72px;
  height: 72px;
`;

const Title = styled.p`
  font-family: Poppins-SemiBold;
  font-size: 24px;
  color: #FF8B48;

  margin: 0 0 0 16px;
`;
